import React, { useContext, useEffect, useState } from 'react';
import { switchArrayItems } from 'utils/helpers';
import LanguageBarItem from 'components/LanguageBarItem/LanguageBarItem';
import { TLanguageIDs } from 'types';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './LanguageBar.module.scss';

const LanguageBar: React.FC = () => {
	const { setStyleLanguage, styleData, selectedStyleLanguage, restaurantForFullInfo } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const [orderedLanguages, setOrderedLanguages] = useState<TLanguageIDs[]>([]);

	useEffect(() => {
		const availableLanguages = styleData ? styleData.mediaSettings.map((el) => el.languageId) : [];
		const indexOfDefaultLanguage = availableLanguages.findIndex(
			(el) => el === restaurantForFullInfo?.defaultLanguageId,
		);
		const orderedByDefaultLanguage = switchArrayItems(availableLanguages, indexOfDefaultLanguage, 0);
		setOrderedLanguages(orderedByDefaultLanguage);
	}, [restaurantForFullInfo?.defaultLanguageId, styleData]);

	useEffect(() => {
		setStyleLanguage(orderedLanguages[0]);
	}, [orderedLanguages]);

	return (
		<>
			{orderedLanguages.length ? (
				<div className={style.container}>
					{orderedLanguages.map((el) => (
						<LanguageBarItem
							onClick={() => setStyleLanguage(el)}
							languageId={el}
							isActive={selectedStyleLanguage === el}
							key={el}
						/>
					))}
				</div>
			) : null}
		</>
	);
};

export default LanguageBar;
